import { createReducer } from '@reduxjs/toolkit'

const findIfElseContent = (section, selectedRow, selectedRowContent) => {
   if (!selectedRowContent && selectedRow.indexOf('if') !== -1) {
      const parentRowId = selectedRow.substring(0, selectedRow.indexOf('if'));
      const parentRow = section.find((content) => content.id === parentRowId);
      return parentRow.config.if.content.find((content) => content.id === selectedRow);
   } else if (!selectedRowContent && selectedRow.indexOf('else') !== -1) {
      const parentRowId = selectedRow.substring(0, selectedRow.indexOf('else'));
      const parentRow = section.find((content) => content.id === parentRowId);
      return parentRow.config.else.content.find((content) => content.id === selectedRow);
   }
   return selectedRowContent;
}

const findIfElseContentList = (section, selectedRow) => {
   if (selectedRow.indexOf('if') !== -1) {
      const parentRowId = selectedRow.substring(0, selectedRow.indexOf('if'));
      const parentRow = section.find((content) => content.id === parentRowId);
      return parentRow.config.if.content;
   } else if (selectedRow.indexOf('else') !== -1) {
      const parentRowId = selectedRow.substring(0, selectedRow.indexOf('else'));
      const parentRow = section.find((content) => content.id === parentRowId);
      return parentRow.config.else.content;
   }
   return section;
}

function findContent(rowId, newHeader, newBody, newFooter) {
   let content;
   if (rowId.indexOf('header') !== -1) {
      content = newHeader.find((content) => content.id === rowId);
      content = findIfElseContent(newHeader, rowId, content);
   } else if (rowId.indexOf('body') !== -1) {
      content = newBody.find((content) => content.id === rowId);
      content = findIfElseContent(newBody, rowId, content);
   } else if (rowId.indexOf('footer') !== -1) {
      content = newFooter.find((content) => content.id === rowId);
      content = findIfElseContent(newFooter, rowId, content);
   }
   return content;
}

function moveItem(from, to, contentList) {
   // const fromIndex = contentList[from].index;
   // const toIndex = contentList[to].index;
   // const fromId = contentList[from].id;
   // const toId = contentList[to].id;
   // // swap index
   // contentList[from].index = toIndex;
   // contentList[to].index = fromIndex;
   // // swap id
   // contentList[from].id = toId;
   // contentList[to].id = fromId;
   // remove `from` item and store it
   let f = contentList.splice(from, 1)[0];
   // insert stored item into position `to`
   contentList.splice(to, 0, f);
}

const updateDesign = (list, name, parentIndex = '') => {
   return list.map((row, index) => {
      let newRow = {
         ...row,
         id: `design_${name}_${parentIndex}${index}`
      }
      if (newRow.type === 'ifelse') {
         newRow.config.if.content = updateDesign(newRow.config.if.content, name, `${index}if${parentIndex}`)
         newRow.config.else.content = updateDesign(newRow.config.else.content, name, `${index}else${parentIndex}`)
      } else if (newRow.type === 'if') {
         newRow.config.if.content = updateDesign(newRow.config.if.content, name, `${index}if${parentIndex}`)
      }
      return newRow;
   });
};


const design = createReducer({ header: [], body: [], footer: [], catalogue: {} }, {
   SAVE_IMAGE: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.config = action.payload.value;
   },
   SAVE_TEXT: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.config.text = action.payload.text;
   },
   SAVE_IFELSE: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.config.condition = action.payload.condition;
   },
   SAVE_EDIT: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.edit = action.payload.value;
   },
   RESET_EDIT: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.edit = action.payload.value;
   },
   MOVE_UP: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      let contentList;
      if (rowId.indexOf('header') !== -1) {
         contentList = state.header;
      } else if (rowId.indexOf('body') !== -1) {
         contentList = state.body;
      } else if (rowId.indexOf('footer') !== -1) {
         contentList = state.footer;
      }
      contentList = findIfElseContentList(contentList, rowId);
      const contentIndex = contentList.findIndex((element) => element === content);
      if (contentIndex > 0) {
         moveItem(contentIndex, contentIndex - 1, contentList);
      }
   },
   MOVE_DOWN: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      let contentList;
      if (rowId.indexOf('header') !== -1) {
         contentList = state.header;
      } else if (rowId.indexOf('body') !== -1) {
         contentList = state.body;
      } else if (rowId.indexOf('footer') !== -1) {
         contentList = state.footer;
      }
      contentList = findIfElseContentList(contentList, rowId);
      const contentIndex = contentList.findIndex((element) => element === content);
      if (contentIndex < contentList.length - 1) {
         moveItem(contentIndex, contentIndex + 1, contentList);
      }
   },
   ALIGN: (state, action) => {
      const rowId = action.payload.rowId;
      const align = action.payload.align;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.align = align;
   },
   DELETE_ROW: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      let contentList;
      if (rowId.indexOf('header') !== -1) {
         contentList = state.header;
      } else if (rowId.indexOf('body') !== -1) {
         contentList = state.body;
      } else if (rowId.indexOf('footer') !== -1) {
         contentList = state.footer;
      }
      contentList = findIfElseContentList(contentList, rowId);
      const contentIndex = contentList.findIndex((element) => element === content);
      contentList.splice(contentIndex, 1);
   },
   ADD_ROW: (state, action) => {
      const type = action.payload.type;
      const rowId = action.payload.rowId;
      let contentList;
      if (rowId.indexOf('header') !== -1) {
         contentList = state.header;
      } else if (rowId.indexOf('body') !== -1) {
         contentList = state.body;
      } else if (rowId.indexOf('footer') !== -1) {
         contentList = state.footer;
      }
      const nextRowIndex = parseInt(rowId.substring(rowId.length - 1)) + 1;
      let nextRowId = rowId.substring(0, rowId.length - 1) + nextRowIndex;
      contentList = findIfElseContentList(contentList, rowId);
      if (type === 'image') {
         contentList.push({
            "type": "image",
            "id": nextRowId,
            "config": {
               "src": "https://placehold.co/600x100",
               "width": 600
            }
         });
      } else if (type === 'text') {
         contentList.push({
            "type": "text",
            "id": nextRowId,
            "config": {
               "text": "Placeholder text",
            }
         });
      } else if (type === 'if') {
         contentList.push({
            "type": "if",
            "id": nextRowId,
            "config": {
               "condition": "Placeholder condition",
               "if": {
                  "content": [
                  ]
               }
            }
         });
      } else if (type === 'ifelse') {
         contentList.push({
            "type": "ifelse",
            "id": nextRowId,
            "config": {
               "condition": "Placeholder condition",
               "if": {
                  "content": [
                  ]
               },
               "else": {
                  "content": [
                  ]
               }
            }
         });
      } else if (type === 'mjml') {
         contentList.push({
            "type": "mjml",
            "id": nextRowId,
            "config": {
               "mjml": "",
               "html": ""
            }
         });
      }
   },
   LOAD_CATALOGUE_DESIGN: (state, action) => {
      const section = action.payload.section;
      const designId = action.payload.designId;
      const selectedDesign = state.catalogue[section][designId];
      state[section] = selectedDesign;
   },
   LOAD_DESIGN: (state, action) => {
      const designId = action.payload.designId;
      const selectedDesign = state.designs[designId];
      state.header = selectedDesign.header;
      state.body = selectedDesign.body;
      state.footer = selectedDesign.footer;
      state.id = selectedDesign.id;
   },
   SET_DESIGNS: (state, action) => {
      const designs = action.payload;

      for (let i = 0; i < designs.length; i++) {
         const design = designs[i].template;
         design.id = designs[i].id;
         design['header'] = updateDesign(design['header'], 'header');
         design['body'] = updateDesign(design['body'], 'body');
         design['footer'] = updateDesign(design['footer'], 'footer');

         state.designs[`design_${designs[i].id}`] = design;
      }
   },
   SET_CATALOGUES: (state, action) => {
      const catalogues = action.payload;
      const headerCatalogues = catalogues.filter((catalogue) => {
         return catalogue.type === 'header';
      });
      const footerCatalogues = catalogues.filter((catalogue) => {
         return catalogue.type === 'footer';
      });
      const headerCataloguesObj = headerCatalogues.reduce(function(acc, cur, i) {
         acc[`header_${i}`] = updateDesign(cur.data, 'header');
         return acc;
      }, {});
      const footerCataloguesObj = footerCatalogues.reduce(function(acc, cur, i) {
         acc[`footer_${i}`] = updateDesign(cur.data, 'footer');
         return acc;
      }, {});

      state.catalogue.header = headerCataloguesObj;
      state.catalogue.footer = footerCataloguesObj;
   },
   NEW_DESIGN: (state, action) => {
      state.header = [];
      state.body = [];
      state.footer = [];
      state.folder = 'assets_01';
   },
   PROJECT_FOLDER: (state, action) => {
      state.folder = action.payload.folder;
   },
   ADD_DESIGN: (state = { designs: []}, action) => {
      state.designs[`design_${action.payload.id}`] = {
         id: action.payload.id,
         header: action.payload.template.header,
         footer: action.payload.template.footer,
         body: action.payload.template.body
      };
      state.id = action.payload.id;
   },
   UPDATE_DESIGN: (state, action) => {
      const updateDesgin = state.designs[`design_${action.payload.id}`];

      updateDesgin.header = action.payload.template.header;
      updateDesgin.footer = action.payload.template.footer;
      updateDesgin.body = action.payload.template.body;
   },
   IMPORT_DESIGN: (state, action) => {
      state.header = action.payload.header || [];
      state.body = action.payload.body || [];
      state.footer = action.payload.footer || [];
   },
   SAVE_MJML: (state, action) => {
      const rowId = action.payload.rowId;
      let content = findContent(rowId, state.header, state.body, state.footer);
      content.config.mjml = action.payload.mjml;
      content.config.html = action.payload.html;
   }
})

export default design;